import React, { PropTypes } from "react";
import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const BSModal = (props) => {
    const handleKeyPress = (e) => {
        if (e.which == 13 && e.target.type != "textarea") {
            e.preventDefault();
            const mainAction = props.actions.filter((a) => a.main === true)[0] || props.actions[0];
            if (mainAction) {
                mainAction.action();
            }
        }
    };

    const handleCloseConfirm = () => {
        if (props.onCloseConfirm && props.onShowConfirm) {
            props.onShowConfirm();
        } else {
            props.onClose();
        }
    };

    return (
        <div>
            <Modal
                className={props.className}
                backdrop={props.backdrop}
                show={props.show}
                onHide={props.onClose}
                onEntered={props.onEntered}
                onExited={props.onExited}
            >
                <div className="modal-main">
                    <Modal.Header>
                        <Modal.Title>{props.title}</Modal.Title>
                        <span className="close" onClick={props.onClose} />
                    </Modal.Header>

                    <Modal.Body className={props.optionalClasses} onKeyPress={handleKeyPress}>
                        {props.children}
                    </Modal.Body>
                </div>

                <Modal.Footer>
                    <div>
                        <Button onClick={handleCloseConfirm}>
                            <FormattedMessage id={props.closeButtonKey || "common.close"} />
                        </Button>
                    </div>
                    {props.actions &&
                        props.actions.map((action) => {
                            return (
                                <div key={action.id}>
                                    <Button
                                        disabled={action.disabled}
                                        bsStyle="primary"
                                        className="btn-filled"
                                        onClick={action.action}
                                    >
                                        {action.text}
                                    </Button>
                                </div>
                            );
                        })}
                </Modal.Footer>
            </Modal>
        </div>
    );
};

BSModal.propTypes = {
    actions: PropTypes.array,
    backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    className: PropTypes.string,
    closeButtonKey: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onClose: PropTypes.func.isRequired,
    onCloseConfirm: PropTypes.func,
    onShowConfirm: PropTypes.func,
    onEntered: PropTypes.func,
    onExited: PropTypes.func,
    show: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    optionalClasses: PropTypes.string,
};

BSModal.defaultProps = {
    backdrop: "static",
    optionalClasses: "",
};

export default BSModal;



// WEBPACK FOOTER //
// ./src/components/common/BSModal.js